import { StaffDashboardPage } from '@/components/dashboard/staff-dashboard-page'

export function CommitteeDashboard() {
  return <StaffDashboardPage basePath="/committee" />
}
